/* eslint-disable sonarjs/no-nested-template-literals */
import { Pipe, PipeTransform, Inject } from '@angular/core';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from './config';

interface CrosOriginLinkOptions {
  secure?: boolean;
  data?: string;
}

@Pipe({
  name: 'crossOriginLink',
})
export class CrossOriginLinkPipe implements PipeTransform {
  constructor(
    @Inject('domainRedirectUrl') private domainRedirect: string,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {}

  transform(
    path: string,
    { secure = true, data = undefined }: CrosOriginLinkOptions = {},
  ): string {
    if (this.envConfig.authMethod === 'auth0') {
      return `${
        this.envConfig.redirect.crossOrigin.domain
      }/app/redirect?destinationUrl=/app${path}${data ? `?data=${data}` : ''}`;
    } else if (secure) {
      return `/pkmscdsso?${
        this.domainRedirect
      }/route/secure/cdssostepup?destinationUrl=/app${path}${
        data ? `?data=${data}` : ''
      }`;
    }
    return `${this.domainRedirect}/app${path}`;
  }
}
